import { InfoSection } from '@components'

import { Link, Space, Switch, Text } from '@billy/design-system'
import { ReactElement, useCallback, useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { DATE_FORMAT } from '@features/vatDeclarations/constants/dateFormat'

import { formatDate } from '../../../../../../utils'
import { FR_AUTHORITY_URL } from '../../../../../vatDeclarations/consts/taxAuthoritiesUrls'
import { useVatDeclarationsSettlePeriodModal } from '../../context/vatDeclarationsSettlePeriodModalContext'

export const ModalBodyFR = (): ReactElement => {
  const { t } = useTranslation()
  const { toggleLockAccounting, periodEndDate } = useVatDeclarationsSettlePeriodModal()

  const lockAccountingDate = useMemo(() => formatDate(periodEndDate, DATE_FORMAT), [periodEndDate])

  const handleLockAccountingToggle = useCallback(() => {
    toggleLockAccounting()
  }, [toggleLockAccounting])

  const infoText = (
    <Trans i18nKey="vat_declarations.settlement_modal.modal_body.body_info_fr">
      Please note that you must submit the figures to the Direction Générale des Finances Publiques (DGFiP) on
      <Link href={FR_AUTHORITY_URL} target="_blank" rel="noreferrer">
        impots.gouv.fr
      </Link>
      yourself.
    </Trans>
  )

  const lockPeriodText = (
    <Text>
      <Trans i18nKey="vat_declarations.settlement_modal.modal_body.lock.label" values={{ date: lockAccountingDate }}>
        Lock accounting from <strong>{lockAccountingDate}</strong>.
      </Trans>
    </Text>
  )

  return (
    <>
      <Text>{t('vat_declarations.settlement_modal.modal_body.body_text_fr')}</Text>
      <Space size="s12" />
      <Text weight="bold">{t('vat_declarations.settlement_modal.modal_body.lock.text_fr')}</Text>
      <Space size="s8" />
      <Switch onChange={handleLockAccountingToggle}>{lockPeriodText}</Switch>
      <InfoSection infoText={infoText} />
    </>
  )
}
